import { useLocation } from 'react-router-dom';
import { ExternalOnboardingStatus } from '../../../../RedirectPage';
import { useEffect } from 'react';
import { notifyDismissible } from '../../../../../components/showNotification';
import { CustomFormattedMessage } from '../../../../../i18n/i18n';

export const useExternalOnboardingNotification = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const externalOnboardingStatus = queryParams.get(
    'externalOnboardingStatus',
  ) as ExternalOnboardingStatus | null;

  useEffect(() => {
    if (!externalOnboardingStatus) return;

    if (externalOnboardingStatus === 'CANCELLED') {
      notifyDismissible(
        'info',
        <CustomFormattedMessage
          id={'base.body.notificationBanner.externalOnboardingCancelled'}
        />,
        'base.body.notificationBanner.externalOnboardingCancelledTitle',
      );
    } else if (externalOnboardingStatus === 'FAILED') {
      notifyDismissible(
        'error',
        <CustomFormattedMessage
          id={'base.body.notificationBanner.externalOnboardingFailed'}
        />,
        'base.body.notificationBanner.externalOnboardingFailedTitle',
      );
    }
  }, [externalOnboardingStatus]);
};
